export type ModuleStyleCapability = "accent" | "spacing" | "align" | "grayscale" | "showTitle";

export type ModuleStyleCapabilities = Record<ModuleStyleCapability, boolean>;

const ALL: ModuleStyleCapabilities = {
  accent: true,
  spacing: true,
  align: true,
  grayscale: true,
  showTitle: true,
};

const OVERRIDES: Record<string, Partial<ModuleStyleCapabilities>> = {
  image: { accent: false, align: false, showTitle: false },
  intro: { accent: false, align: false, showTitle: false },
  toc: { accent: false, grayscale: false },
  faq: { accent: false, grayscale: false },
  "before-after-annotated": { accent: false },
  "before-after-slider": { accent: false },
  "correlation-heatmap": { accent: false },
  "delta-comparison": { accent: false },
  candlestick: { accent: false },
  "profit-loss": { accent: false },
  heatmap: { accent: false },
};

export function moduleStyleCapabilities(type: string | undefined): ModuleStyleCapabilities {
  const override = type ? OVERRIDES[type] : undefined;
  return override ? { ...ALL, ...override } : ALL;
}
